<!-- Quote Symbol section -->
<div class="td-wb-detailed-quote-summary-symbol-detail">
  <!-- Underlying quote Name -->
  @if (displayName) {
    <div class="td-wb-detailed-quote-summary-symbol-detail__row"
         [innerText]="quote.name">
    </div>
  }
  <div class="td-wb-detailed-quote-summary-symbol-detail__row td-wb-detailed-quote-summary-symbol-detail__row--ticker">
    @if (!isMutualFund()) {
      <td-wb-icon-flag class="td-wb-detailed-quote-summary-symbol-detail__flag"
                       [value]="quote.country" />
    }
    <span class="td-wb-detailed-quote-summary-symbol-detail__symbol"
          [innerText]="quote.symbol"></span>
  </div>
  <!-- Last Price & Today's Change -->
  <div class="td-wb-detailed-quote-summary-symbol-detail__row">
    @if (isMutualFund()) {
      <div>
        <!-- show lastPrice if nav is null -->
        @if (quote.nav) {
          <span [innerText]="quote.nav | tdWbCurrency : { format: 'c4-2', emptyPlaceholder:'-'}"></span>
        } @else {
          <span [innerText]="quote.lastPrice | tdWbCurrency : { format: 'c4-2', emptyPlaceholder:'-'}"></span>
        }
      </div>
    }
    @if (!isMutualFund()) {
      <div [innerText]="quote.lastPrice  | tdWbCurrency : { format: 'c4-2', emptyPlaceholder:'-'}"></div>
    }
    <div>
      <td-wb-todays-change [quote]="quote" />
    </div>
  </div>
</div>
